@if (!loading) {
  <div class="notFound">
    <div class="flex">
      <div aria-hidden="true" class="error__head">{{ 'frontpage.message' | translate }}</div>
      @if (!redirectUrl) {
        <div
          aria-hidden="true"
          class="error__explanation"
          innerHtml="{{ 'notFound.explanation' | translate }}">
        </div>
      } @else {
        <div class="error__explanation" aria-hidden="true">
          {{ 'frontpage.login_required_message' | translate }}
        </div>
      }
      <div class="error__button">
        <button
          id="toFront"
          htm-button
          aria-live="assertive"
          theme="default"
          (click)="action()">
          @if (!redirectUrl) {
            {{ 'frontpage.navigate' | translate }}
          } @else {
            {{ 'button.login' | translate }}
          }
        </button>
      </div>
      <div class="error__links">
        <a [routerLink]="'/my-data/document-pocket' | translatePath"><span>{{'breadcrumbs.document_pocket' | translate}}</span></a>
        <a [routerLink]="'/my-data/applications' | translatePath"><span>{{'breadcrumbs.applications' | translate}}</span></a>
        <a [routerLink]="'/free-courses' | translatePath"><span>{{'breadcrumbs.free_courses_adults' | translate}}</span></a>
      </div>
    </div>
  </div>
}
